import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import { AuthGuard } from 'guards/AuthGuard';
import DashboardLayout from '../layouts/dashboard';
import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
// components
import {
  LoginPage,
  CreateBannerPage,
  CreateSliderPage,
  HomePage,
  NotFoundPage,
  SlidersListPage,
  SliderDetailPage,
  SliderEditPage,
  TemplateDetailPage,
  UpdateDetailPage,
  CvDetailPage,
  TemplateListPage,
  TemplateNewRequest,
  BannerDetailPage,
  BannersListPage,
  EditBannerPage,
  CreateFeaturePage,
  EditFeaturePage,
  FeatureDetailPage,
  FeaturesListPage,
  CreateTagPage,
  EditTagPage,
  TagDetailPage,
  TagsListPage,
  GalleryPage,
  EditRequets,
  LogOutPage,
  WebinarAll,
  WebinarConductor,
  WebinarNewRequests,
  WebinarRequestDetails,
  OnBoardWebinars,
  CreateRecommendationConflict,
  CreateRecommendationQuestion,
  CreateRecommendationTag,
  EditRecommendationConflict,
  EditRecommendationQuestion,
  EditRecommendationTag,
  ListRecommendationConflict,
  ListRecommendationQuestion,
  ListRecommendationTag,
  EditRecommendationRelation,
  ListRecommendationRelation,
} from './element';
import { PATH_AUTH, PATH_DASHBOARD } from './paths';

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to="/dashboard" replace />,
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: '/dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_DASHBOARD.request.list} replace />, index: true },
        { path: 'index', element: <HomePage /> },
        {
          path: 'request',
          children: [
            {
              element: <Navigate to={PATH_DASHBOARD.request.list} replace />,
              index: true,
            },
            { path: PATH_DASHBOARD.request.list, element: <TemplateListPage /> },
            { path: '/dashboard/request/detail/:id', element: <TemplateDetailPage /> },
            { path: '/dashboard/request/update/detail/:id', element: <UpdateDetailPage /> },
            { path: '/dashboard/request/cvDetail/:id', element: <CvDetailPage /> },
            { path: PATH_DASHBOARD.request.newRequest, element: <TemplateNewRequest /> },
            { path: PATH_DASHBOARD.request.edit, element: <EditRequets /> },
          ],
        },
        {
          path: 'webinar',
          children: [
            {
              element: <Navigate to={PATH_DASHBOARD.webinar.newRequests} replace />,
              index: true,
            },
            { path: PATH_DASHBOARD.webinar.all, element: <WebinarAll /> },
            { path: PATH_DASHBOARD.webinar.conductor, element: <WebinarConductor /> },
            { path: PATH_DASHBOARD.webinar.newRequests, element: <WebinarNewRequests /> },
            { path: '/dashboard/webinar/detail/:id', element: <WebinarRequestDetails /> },
            { path: PATH_DASHBOARD.webinar.onboard, element: <OnBoardWebinars /> },
            // { path: PATH_DASHBOARD.request.edit, element: <EditRequets /> },
          ],
        },
        {
          path: 'slider',
          children: [
            {
              element: <Navigate to={PATH_DASHBOARD.slider.list} replace />,
              index: true,
            },
            { path: PATH_DASHBOARD.slider.list, element: <SlidersListPage /> },
            { path: PATH_DASHBOARD.slider.create, element: <CreateSliderPage /> },
            { path: '/dashboard/slider/detail/:id', element: <SliderDetailPage /> },
            { path: '/dashboard/slider/edit/:id', element: <SliderEditPage /> },
          ],
        },
        {
          path: 'banner',
          children: [
            {
              element: <Navigate to={PATH_DASHBOARD.banner.list} replace />,
              index: true,
            },
            { path: PATH_DASHBOARD.banner.list, element: <BannersListPage /> },
            { path: PATH_DASHBOARD.banner.create, element: <CreateBannerPage /> },
            { path: '/dashboard/banner/detail/:id', element: <BannerDetailPage /> },
            { path: '/dashboard/banner/edit/:id', element: <EditBannerPage /> },
          ],
        },
        {
          path: 'feature',
          children: [
            {
              element: <Navigate to={PATH_DASHBOARD.feature.list} replace />,
              index: true,
            },
            { path: PATH_DASHBOARD.feature.list, element: <FeaturesListPage /> },
            { path: PATH_DASHBOARD.feature.create, element: <CreateFeaturePage /> },
            { path: '/dashboard/feature/detail/:id', element: <FeatureDetailPage /> },
            { path: '/dashboard/feature/edit/:id', element: <EditFeaturePage /> },
          ],
        },
        {
          path: 'tag',
          children: [
            {
              element: <Navigate to={PATH_DASHBOARD.tag.list} replace />,
              index: true,
            },
            { path: PATH_DASHBOARD.tag.list, element: <TagsListPage /> },
            { path: PATH_DASHBOARD.tag.create, element: <CreateTagPage /> },
            { path: '/dashboard/tag/detail/:id', element: <TagDetailPage /> },
            { path: '/dashboard/tag/edit/:id', element: <EditTagPage /> },
          ],
        },
        {
          path: 'recommendation',
          children: [
            {
              path: 'tag',
              children: [
                {
                  element: <Navigate to={PATH_DASHBOARD.recommendation.tag.list} replace />,
                  index: true,
                },
                { path: PATH_DASHBOARD.recommendation.tag.list, element: <ListRecommendationTag /> },
                { path: PATH_DASHBOARD.recommendation.tag.create, element: <CreateRecommendationTag /> },
                { path: PATH_DASHBOARD.recommendation.tag.edit, element: <EditRecommendationTag /> },
              ],
            },
            {
              path: 'question',
              children: [
                {
                  element: <Navigate to={PATH_DASHBOARD.recommendation.question.list} replace />,
                  index: true,
                },
                { path: PATH_DASHBOARD.recommendation.question.list, element: <ListRecommendationQuestion /> },
                { path: PATH_DASHBOARD.recommendation.question.create, element: <CreateRecommendationQuestion /> },
                { path: PATH_DASHBOARD.recommendation.question.edit, element: <EditRecommendationQuestion /> },
              ],
            },
            {
              path: 'conflict',
              children: [
                {
                  element: <Navigate to={PATH_DASHBOARD.recommendation.conflict.list} replace />,
                  index: true,
                },
                { path: PATH_DASHBOARD.recommendation.conflict.list, element: <ListRecommendationConflict /> },
                { path: PATH_DASHBOARD.recommendation.conflict.create, element: <CreateRecommendationConflict /> },
                { path: PATH_DASHBOARD.recommendation.conflict.edit, element: <EditRecommendationConflict /> },
              ],
            },
            {
              path: 'relation',
              children: [
                {
                  element: <Navigate to={PATH_DASHBOARD.recommendation.relation.list} replace />,
                  index: true,
                },
                { path: PATH_DASHBOARD.recommendation.relation.list, element: <ListRecommendationRelation /> },
                { path: PATH_DASHBOARD.recommendation.relation.edit, element: <EditRecommendationRelation /> },
              ],
            },
          ],
        },
        {
          path: 'gallery',
          element: <GalleryPage />,
        },
      ],
    },
    { path: PATH_AUTH.logout, element: <LogOutPage /> },

    {
      path: '*',
      element: <LogoOnlyLayout />,
      children: [
        { path: '404', element: <NotFoundPage /> },
        { path: '*', element: <Navigate to="/404" replace /> },
      ],
    },

    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
